import { useState, useContext, useEffect, useCallback } from 'react';
import { UserContext } from '../context/UserContext';
import {APIGetCompanyAccess} from '../api/companies/Companies';
import {CompanyBadge} from "#src/helper/userHelper";
import {UserManagementMenu} from './userManagementMenu';

export const AccessManagementCompany = () => {
    const { user } = useContext(UserContext);
    const [companies, setCompanies] = useState([]);

    
    const accessOptions = [
        {id: 1, value: 'admin', name: 'Admistrator'},
        {id: 2, value: 'user', name: 'Benutzer'},
    ]

    const isCurrentCompany = (companyId) => {
        return user.companyId === companyId;
      }

    const fetchCompanies = useCallback(async () => {
        try {
            const companyAccess = await APIGetCompanyAccess(user.companyId);
            setCompanies(companyAccess);
        } catch (error) {
            console.error('Error:', error);
        }
    }, [user.companyId]);
    

    useEffect(() => {
        
        fetchCompanies();
    }, [fetchCompanies, user.companyId]);

    if (companies.length === 0) {
        return null;
    }

    return (
        <div className="border border-gray-500 rounded-lg bg-white w-full p-6 mb-8">
            <div className="flex rounded">
                <h1 className="text-lg font-semibold text-lg text-gray-900">
                    Untergeordnete Accounts
                </h1>
            </div>
            <div className="mt-6">
                <div className='flex flex-col'>
                    {companies.map((company, index) => {
                        return (
                            <div key={index} className="flex justify-between items-center p-2 hover:bg-gray-200">
                                <div className='flex items-center gap-4'>
                                    <div>
                                        {CompanyBadge(company.name, 9, 'xs', isCurrentCompany(company.target_id))}
                                    </div>
                                    <div className='flex flex-col gap-1'>
                                        <div>
                                            {company.name || 'Unbekannt'}
                                        </div>
                                        {/* <div className='text-xs font-light text-gray-550'>
                                            {company.user_email}
                                        </div> */}
                                    </div>
                                </div>
                                <div className='flex items-center gap-4'>
                                    <div className='text-sm text-gray-600'>
                                        {accessOptions.find( option => option.value ===company.permission).name}
                                    </div>
                                    {/* <UserManagementMenu associate={company} getAssociates={fetchCompanies} associates={companies} userView={true}/> */}
                                </div>
                            </div>
                        )
                    }
                    )}
                </div>
            </div>
        </div>
    );
}
